import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GET_PROGRAM_BOOKINGS_SUMMARY, GET_PROGRAM_BOOKINGS_SUMMARY_ERROR, GET_PROGRAM_BOOKINGS_SUMMARY_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getProgramBookingsSummary({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/bookings/summary`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.params,
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROGRAM_BOOKINGS_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROGRAM_BOOKINGS_SUMMARY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROGRAM_BOOKINGS_SUMMARY_ERROR, payload: error });
  }
}

export function* watchGetProgramBookingsSummary() {
  yield takeEvery(GET_PROGRAM_BOOKINGS_SUMMARY, getProgramBookingsSummary);
}

function* getProgramBookingsSummarySaga() {
  yield all([fork(watchGetProgramBookingsSummary)]);
}

export default getProgramBookingsSummarySaga;
